// @flow
import styled from "styled-components";

export const Page = styled.div`
    min-height: 100vh;
`;

export const Mobile = styled.div`
    display: inherit;
    @media only screen and (min-width: 560px) {
        display: none;
    }
`;

export const Desktop = styled.div`
    display: inherit;
    @media only screen and (max-width: 560px) {
        display: none;
    }
`;



// WEBPACK FOOTER //
// ./src/styled.js